import { render } from "./HeaderSection.vue?vue&type=template&id=3da0ef9c&scoped=true&ts=true"
import script from "./HeaderSection.vue?vue&type=script&lang=ts"
export * from "./HeaderSection.vue?vue&type=script&lang=ts"

import "./HeaderSection.vue?vue&type=style&index=0&id=3da0ef9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da0ef9c"]])

export default __exports__